import {
  formatDateCSV,
  generateCSV,
  getSaleRecords,
  currentDate,
  blob,
  trackMTDAnalytics,
} from './utils';
import { REPORT_TYPE } from './types';

export const serveCSV = async (reportName: REPORT_TYPE, dates: string[]) => {
  if (dates === undefined) throw new Error('No date specified');
  if (dates.length !== 2) throw new Error('Please specify both a start date and an end date');

  const accountID = String(window.merchantos.session.getSystemCustomerID());

  let offset = 0;
  let nextPage = true;
  const results = [];

  while (nextPage) {
    // eslint-disable-next-line no-await-in-loop
    const salesResponse = await fetch(
      `/API/Account/${accountID}/DisplayTemplate/Sale.json?&offset=${offset}&completed=true&completeTime=><,${formatDateCSV(
        dates
      )}`,
      {
        credentials: 'same-origin',
      }
    )
      .then(response => {
        trackMTDAnalytics('API salesResponse: Success', reportName, accountID);
        return response.json();
      })
      .catch(error => {
        // Google analytics
        trackMTDAnalytics('API salesResponse: Fail', reportName, accountID);
        // eslint-disable-next-line no-console
        console.error('OH SNAP', error);
      });

    // eslint-disable-next-line no-prototype-builtins
    if (salesResponse.hasOwnProperty('Sale')) {
      Array.isArray(salesResponse.Sale)
        ? results.push(...salesResponse.Sale)
        : results.push(salesResponse.Sale);

      offset += 100;
    } else {
      nextPage = false;
    }
  }

  const saleRecords = getSaleRecords(results, reportName);
  const csv = await generateCSV(saleRecords);

  const link = document.createElement('a');
  const url = URL.createObjectURL(blob(csv));

  link.setAttribute('href', url);
  link.setAttribute('download', `${reportName}-Accounting_${currentDate()}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);

  try {
    link.click();
    document.body.removeChild(link);
    trackMTDAnalytics('Download: Success', reportName, accountID);
    return;
  } catch (error) {
    trackMTDAnalytics('Download: Fail', reportName, accountID);
  }
};
